import { ThunkAction } from 'redux-thunk'
import { RootState } from '..'
import { shiftApi } from '../../apis/shiftApi'
import { ShiftEntity, ShiftFilter } from '../../models'
import {
  SET_SELECTED_SHIFT,
  SET_SHIFTS,
  SET_SHIFTS_LOADED,
  SET_SHIFT_FILTER,
  ShiftAction,
} from '../types'
import { loadProfile } from './authAction'

export const setShifts = (shifts: ShiftEntity[]): ShiftAction => ({
  type: SET_SHIFTS,
  payload: shifts,
})

export const setSelectedShift = (shift?: ShiftEntity): ShiftAction => ({
  type: SET_SELECTED_SHIFT,
  payload: shift,
})

export const setShiftFilter = (shiftFilter: ShiftFilter): ShiftAction => ({
  type: SET_SHIFT_FILTER,
  payload: shiftFilter,
})

export const setShiftsLoaded = (loaded: boolean): ShiftAction => ({
  type: SET_SHIFTS_LOADED,
  payload: loaded,
})

export const loadShifts = (): ThunkAction<
  void,
  RootState,
  null,
  ShiftAction
> => {
  return async (dispatch) => {
    try {
      dispatch(setShiftsLoaded(false))
      const resp = await shiftApi.getShifts()
      dispatch(setShifts(resp.data.data))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await shiftApi.getShifts()
        dispatch(setShifts(resp.data.data))
      }
    } finally {
      dispatch(setShiftsLoaded(true))
    }
  }
}
